import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface VideoCardProps {
  id: string;
  title: string;
  thumbnail: string;
  duration: string;
  categoryName: string;
  views: number;
  badge?: string;
}

export default function VideoCard({ id, title, thumbnail, duration, categoryName, views, badge }: VideoCardProps) {
  const { t } = useTranslation();

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <article className="group cursor-pointer animate-scale-in" data-product-shop>
      <div className="relative rounded-lg overflow-hidden aspect-video bg-background-200">
        <img
          src={thumbnail}
          alt={title}
          title={`${title} - 黄瓜视频在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        {badge && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
            {badge}
          </span>
        )}
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded text-xs font-medium bg-black/70 text-background-50 whitespace-nowrap">
          {duration}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl"></i>
          </div>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
          {title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{categoryName}</span>
          <span className="whitespace-nowrap">{formatViews(views)} {t('video.views')}</span>
        </div>
      </div>
    </article>
  );
}